import dayjs from "dayjs";
import MinMax from "dayjs/plugin/minMax";
import {
  type OrderGetOrderDetailsOrderItemReadDto,
  type OrderItemDetailsReadDto,
} from "@/config/apiClient";
import { OrderItemLogActionTypeEnum } from "@/config/apiClient.types";

dayjs.extend(MinMax);

export const spliceActionLog = (
  actionLogs:
    | OrderItemDetailsReadDto["OrderLog"]
    | OrderGetOrderDetailsOrderItemReadDto["OrderLog"]
) => {
  let filteredActionLogs = actionLogs.toSorted((a, b) =>
    dayjs(a.createdAt).diff(dayjs(b.createdAt))
  );

  // START MODIFICATION REQUEST LOGIC
  // Get last occured events on ModificationRequest
  const requestModificationCreatedLastIndex = filteredActionLogs.findLastIndex(
    (log) =>
      log.actionType === OrderItemLogActionTypeEnum.CREATED_MODIFICATION_REQUEST
  );

  const modificationRequestValidatedLogIndex = filteredActionLogs.findLastIndex(
    (log) =>
      log.actionType ===
      OrderItemLogActionTypeEnum.ACCEPTED_MODIFICATION_REQUEST
  );

  const actionLogsToKeepAfterQuoteOrModificationRequestChanges =
    filteredActionLogs.filter(
      (actionLog) =>
        actionLog.actionType.indexOf("PRE_MEDIA") !== -1 ||
        actionLog.actionType.indexOf("PLANNING") !== -1 ||
        actionLog.actionType.indexOf("ADD_ORDER_NUMBER") !== -1 ||
        actionLog.actionType.indexOf("CREATED_MODIFICATION_REQUEST") !== -1 ||
        actionLog.actionType.indexOf("ADD_GRAPHIC") !== -1 ||
        actionLog.actionType.indexOf("DELIVERY_LABEL_SUBMITTED") !== -1
    );
  // Restart Flow if Accepted Modification Request
  if (
    modificationRequestValidatedLogIndex > 0 &&
    requestModificationCreatedLastIndex > 0
  ) {
    filteredActionLogs = [
      ...actionLogsToKeepAfterQuoteOrModificationRequestChanges,
      ...filteredActionLogs.slice(modificationRequestValidatedLogIndex + 1),
      ...filteredActionLogs.slice(requestModificationCreatedLastIndex + 1),
    ];
  }

  // END MODIFICATION REQUEST LOGIC

  // START QUOTE LOGIC
  // Get last quote creation event
  const quoteCreated = filteredActionLogs.findLast(
    (log) => log.actionType === OrderItemLogActionTypeEnum.QUOTE_AVAILABLE
  );
  // Check if a quote was refused after the last quote creation
  const quoteRefusedOrCancelledIndex = filteredActionLogs.findLastIndex(
    (log) =>
      (log.actionType === OrderItemLogActionTypeEnum.QUOTE_REFUSED ||
        log.actionType === OrderItemLogActionTypeEnum.QUOTE_CANCELLED) &&
      (quoteCreated
        ? dayjs(log.createdAt).isAfter(dayjs(quoteCreated.createdAt))
        : false)
  );

  // If we found a quote refused event, we remove the quote events so that it goes back to the quote creation possibility
  if (quoteRefusedOrCancelledIndex) {
    filteredActionLogs = [
      ...actionLogsToKeepAfterQuoteOrModificationRequestChanges,
      ...filteredActionLogs.slice(quoteRefusedOrCancelledIndex + 1),
    ];
  }
  // END QUOTE LOGIC

  return filteredActionLogs;
};
